import { j as r } from "../../../jsx-runtime-DmTjM30f.js";
import { forwardRef as n } from "react";
import { Button as m } from "../base/index.js";
const s = n(
  ({ ...t }, o) => /* @__PURE__ */ r.jsx(m, { iconButton: !0, ref: o, ...t })
);
export {
  s as IconButton,
  s as default
};
